import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  closedButton: {
    alignItems: 'flex-start',
  },
  openedButton: {
    marginLeft: '13.5rem',
  },
  icon: {
    fontSize: '2rem',
  },
}));

export default useStyles;
